<div class="section-title">
    {{ 'mimic.settings.system-integration.title' | translate }}
</div>
<app-default-element-settings
    #motorElemSetting
    [selectedElement]="selectedElement"
    [vessel]="vessel"
    [mimicId]="mimicId"
    [userCanEdit]="userCanEdit"
    [elementSettings]="elementSettings"
    [elementIntegration]="elementIntegration">
</app-default-element-settings>

<ng-container *ngIf="hasAssignedChannel">
    <div class="section-title">
        {{ 'mimic.settings.sensor.title' | translate }}
    </div>
    <div class="sensor-section">
        <app-alarm-color-indicator
            [title]="'channel.label.alarm.fu-unresponsive'"
            [color]="fuUnresponsiveColor"
            [enabled]="true"
            [showAlpha]="false">
        </app-alarm-color-indicator>
    </div>
</ng-container>
